<div class="naplo-wrap">
  <ion-card class="naplo-card">
    <ion-card-header>
      <ion-card-title style="font-size:1.05rem;color:var(--naplo)"><ion-icon name="mail"></ion-icon> E-mail aláírás (S/MIME)</ion-card-title>
      <ion-card-subtitle>
        A kimenő e-maileket a rendszer digitálisan aláírja, ha kijelölsz egy aláíró tanúsítványt.
        <b>Fontos:</b> a tanúsítvány e-mail címe egyezzen a küldő címmel, különben a levelezők érvénytelennek jelzik.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div *ngIf="smime.kijelolt" class="allapot" [class.betoltve]="smime.betoltve">
        <ion-icon [name]="smime.betoltve ? 'shield-checkmark' : 'warning'"></ion-icon>
        Aktív aláíró: <b>{{ smime.kijelolt.owner || smime.kijelolt.name }}</b>
        (lejár: {{ smime.kijelolt.validto | date:'yyyy-MM-dd' }})
        <span *ngIf="!smime.betoltve" style="color:#c00">&nbsp;– nem tölthető be (jelszó?)</span>
        <ion-button size="small" fill="clear" color="medium" (click)="alairasKi()">Kikapcsolás</ion-button>
      </div>
      <div *ngIf="!smime.kijelolt" class="allapot">
        <ion-icon name="information-circle"></ion-icon> Jelenleg nincs kijelölt aláíró – a levelek aláíratlanul mennek.
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card class="naplo-card">
    <ion-card-header>
      <ion-card-title style="font-size:1.05rem;color:var(--naplo)"><ion-icon name="cloud-upload"></ion-icon> Tanúsítvány feltöltése</ion-card-title>
      <ion-card-subtitle>.p12 vagy .pfx fájl a hozzá tartozó jelszóval (privát kulcsot is tartalmaznia kell).</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="feltolt-sor">
        <input type="file" accept=".p12,.pfx" (change)="valaszt($event)" />
        <ion-input class="szuk" fill="outline" type="password" [(ngModel)]="jelszo" placeholder="Tanúsítvány jelszava"></ion-input>
        <ion-button color="primary" [disabled]="!file || feltoltes" (click)="feltolt()">
          <ion-icon slot="start" name="cloud-upload"></ion-icon> Feltöltés
        </ion-button>
      </div>
      <p *ngIf="fileNev" class="halvany" style="margin:6px 2px 0">Kiválasztva: {{ fileNev }}</p>
    </ion-card-content>
  </ion-card>

  <ion-card class="naplo-card">
    <ion-card-header>
      <ion-card-title style="font-size:1.05rem;color:var(--naplo)"><ion-icon name="ribbon"></ion-icon> Tanúsítványok</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <div class="tabla-wrap">
        <table class="naplo-tabla">
          <thead><tr><th>Név</th><th>Tulajdonos</th><th>Kiállító</th><th>Lejárat</th><th class="kozep">Jelszó</th><th class="kozep">E-mail aláíró</th><th>Műveletek</th></tr></thead>
          <tbody>
            <tr *ngFor="let c of certek">
              <td>{{ c.name }}</td>
              <td>{{ c.owner }}</td>
              <td class="halvany">{{ c.issuer }}</td>
              <td>{{ c.validto | date:'yyyy-MM-dd' }}</td>
              <td class="kozep"><span *ngIf="c.jelszo_beallitva" style="color:var(--naplo)">✔</span><span *ngIf="!c.jelszo_beallitva" style="color:#c00">hiányzik</span></td>
              <td class="kozep"><ion-icon *ngIf="c.smime" name="mail" color="tertiary" title="Ez az e-mail-aláíró"></ion-icon></td>
              <td style="white-space:nowrap">
                <ion-button size="small" color="tertiary" [disabled]="c.smime" (click)="emailAlairo(c)" title="E-mail aláíróvá tesz">
                  <ion-icon slot="icon-only" name="mail"></ion-icon>
                </ion-button>
                <ion-button size="small" color="danger" (click)="torol(c)" title="Törlés">
                  <ion-icon slot="icon-only" name="trash"></ion-icon>
                </ion-button>
              </td>
            </tr>
            <tr *ngIf="!certek.length"><td colspan="7" class="halvany" style="text-align:center;padding:14px">Nincs feltöltött tanúsítvány.</td></tr>
          </tbody>
        </table>
      </div>
    </ion-card-content>
  </ion-card>
</div>
